export default __webpack_public_path__ + "static/media/paytmIcon.5acbf3ec.png";